(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grosveld-actiebalk"] && !Shopify.designMode) return;
  try {
    
  // De balk hangt aan twee voorwaarden: je bent ver genoeg naar beneden, en je
  // hebt het doel nog niet gehad. `boundingClientRect.top < 0` vangt het geval
  // waarin het formulier al boven de bovenrand is verdwenen — dan is hij ook
  // "gehad", ook al is hij op dat moment niet zichtbaar.
  const startActiebalk = () => {
    const balken = document.querySelectorAll('.grosveld-actiebalk');

    balken.forEach((balk) => {
      const drempel = Number(balk.dataset.drempel || 240);
      let bereikt = false;

      const werkbij = () => {
        const verGenoeg = window.scrollY > drempel;
        balk.toggleAttribute('data-zichtbaar', verGenoeg && !bereikt);
      };

      const doel = balk.dataset.doel ? document.querySelector(balk.dataset.doel) : null;

      if (doel) {
        const kijker = new IntersectionObserver((items) => {
          items.forEach((item) => {
            bereikt = item.isIntersecting || item.boundingClientRect.top < 0;
            werkbij();
          });
        });
        kijker.observe(doel);
      }

      window.addEventListener('scroll', werkbij, { passive: true });
      werkbij();
    });
  };

  document.addEventListener('DOMContentLoaded', startActiebalk);
  if (document.readyState !== 'loading') startActiebalk();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grosveld-showroom"] && !Shopify.designMode) return;
  try {
    
  // De speler wordt pas ingeladen als de sectie in beeld komt, en loopt dan
  // gedempt door. Tot dat moment kost de video niets: geen iframe, geen script
  // van YouTube, geen cookie. Wie nooit tot hier scrollt, laadt hem ook nooit.
  const laadSpeler = (plek) => {
    if (plek.dataset.geladen) return;
    plek.dataset.geladen = 'ja';

    const iframe = document.createElement('iframe');
    iframe.src = plek.dataset.embed;
    iframe.title = plek.dataset.titel;
    iframe.allow = 'autoplay; encrypted-media';
    iframe.setAttribute('tabindex', '-1');
    plek.replaceWith(iframe);
  };

  const start = () => {
    // Het stilstaande beeld: ook voor wie bewegende beelden heeft uitgezet,
    // dus vóór die controle hieronder.
    const beelden = document.querySelectorAll('.grosveld-showroom__beeld:not(.is-dichtbij)');
    if (beelden.length) {
      const beeldKijker = new IntersectionObserver(
        (items) => {
          items.forEach((item) => {
            if (!item.isIntersecting) return;
            item.target.classList.add('is-dichtbij');
            beeldKijker.unobserve(item.target);
          });
        },
        { rootMargin: '600px' }
      );
      beelden.forEach((beeld) => beeldKijker.observe(beeld));
    }

    const plekken = document.querySelectorAll('.grosveld-showroom__speler');
    if (!plekken.length) return;

    // Wie bewegende beelden heeft uitgezet in zijn systeem krijgt het
    // stilstaande beeld. Een video die vanzelf begint is precies waar die
    // instelling voor bedoeld is.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const kijker = new IntersectionObserver(
      (items) => {
        items.forEach((item) => {
          if (!item.isIntersecting) return;
          laadSpeler(item.target);
          kijker.unobserve(item.target);
        });
      },
      { rootMargin: '200px' }
    );

    plekken.forEach((plek) => kijker.observe(plek));
  };

  document.addEventListener('DOMContentLoaded', start);
  if (document.readyState !== 'loading') start();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // Grosveld: de menubalk wisselt mee met de dia die in beeld staat.
  //
  // Boven de hero is de header doorzichtig en krijgt hij één vaste tekstkleur
  // voor de hele pagina — het thema leest niets aan de foto af. Met drie dia's
  // die om en om licht en donker zijn klopt die ene kleur dus op hoogstens de
  // helft: bij een donkere dia stond er zwarte tekst op een zwarte foto.
  //
  // Welke dia witte koptekst wil staat in de dia zelf, als een leeg element dat
  // de blokinstelling neerzet. Dit script kijkt alleen welke dia zichtbaar is
  // (`aria-hidden="false"`, dat zet de slideshow al voor toegankelijkheid) en
  // hangt de klasse aan de header. Geen kleurmeting, geen canvas, geen CORS.
  //
  // Alleen wanneer de header werkelijk over het beeld ligt: is hij niet
  // doorzichtig, dan staat hij op zijn eigen grond en heeft de foto er niets
  // mee te maken.
  (() => {
    const start = () => {
      const header = document.querySelector('.header');
      if (!header) return;

      // WIE HEEFT DE LEIDING. Staat de glazen header aan, dan meet die zelf wat
      // er onder de balk ligt, inclusief de foto van de dia en de sluier
      // erover. Twee mechanismen die allebei de tekstkleur zetten gaan elkaar
      // tegenspreken, dus dan houdt dit script zich stil.
      //
      // Deze blijft dus over voor de doorzichtige header zónder glas: daar
      // draait de meting niet en is de blokinstelling per dia het enige wat er
      // is. Staat de header op zijn eigen grond, dan ligt hij niet over de foto
      // en doet de regel hieronder over `top` de rest.
      const component = document.getElementById('header-component');
      if (component && component.hasAttribute('data-header-blur')) return;

      const secties = document.querySelectorAll('.slideshow-section');
      if (!secties.length) return;

      // Alleen de bovenste slideshow op de pagina zit achter de header.
      const eerste = secties[0];
      if (eerste.getBoundingClientRect().top > 4) return;

      const dias = [...eerste.querySelectorAll('slideshow-slide')];
      if (dias.length < 2) return;

      const bijwerken = () => {
        const actief = dias.find((d) => d.getAttribute('aria-hidden') === 'false') ?? dias[0];
        header.classList.toggle('header--kop-licht', !!actief.querySelector('.grosveld-kop-licht'));
      };

      const kijker = new MutationObserver(bijwerken);
      dias.forEach((d) => kijker.observe(d, { attributes: true, attributeFilter: ['aria-hidden'] }));
      bijwerken();
    };

    document.addEventListener('DOMContentLoaded', start);
    if (document.readyState !== 'loading') start();
  })();

  // Grosveld: doorschuiven dat niet stopt zodra de muis erop staat.
  //
  // WAAROM OVERNEMEN EN NIET REPAREREN. De tijdklok van het thema zit in een
  // privéveld van de component (`#interval`), en de twee plekken die hem
  // stilzetten — een `mouseenter`-luisteraar en een `:hover`-controle bínnen de
  // tik — zijn van buitenaf geen van beide te bereiken. Wat wel kan is het
  // attribuut `autoplay` weghalen: zonder dat attribuut is `autoplay` in de
  // component onwaar, doet `resume()` niets meer en blijft de klok van het
  // thema uit. Daarna telt alleen onze eigen klok nog, die gewoon `next()`
  // aanroept — dezelfde openbare methode die de stippen ook gebruiken. We
  // schrijven dus niets van de carrousel zelf opnieuw, alleen wanneer hij
  // doorschuift.
  //
  // WIE LIEVER GEEN BEWEGING HEEFT KRIJGT ER GEEN. Bij `prefers-reduced-motion`
  // slaan we het doorschuiven helemaal over. Het thema maakte de overgang in
  // dat geval alleen sprongsgewijs, maar iets dat uit zichzelf van inhoud
  // wisselt is precies wat die instelling bedoelt tegen te houden — en er is
  // hier geen pauzeknop meer om het mee stil te zetten.
  //
  // Na een tik op een stip begint de klok opnieuw. Anders springt de dia die je
  // net zelf koos na een halve seconde alweer weg.
  (() => {
    const stil = window.matchMedia('(prefers-reduced-motion: reduce)');

    const start = () => {
      for (const el of document.querySelectorAll('[data-grosveld-doorschuiven]')) {
        const seconden = parseFloat(el.getAttribute('data-grosveld-doorschuiven'));
        if (!(seconden > 0) || typeof el.next !== 'function') continue;

        el.removeAttribute('autoplay');
        if (typeof el.pause === 'function') el.pause();
        if (stil.matches) continue;

        let klok;
        const herstart = () => {
          clearInterval(klok);
          klok = setInterval(() => {
            // Een dia die op dat moment versleept wordt laten we met rust; de
            // rest van de tijd schuift hij door, muis of geen muis.
            if (document.hidden || el.hasAttribute('dragging')) return;
            el.next();
          }, seconden * 1000);
        };

        el.addEventListener('slideshow:select', (e) => {
          if (e.detail && e.detail.userInitiated) herstart();
        });

        herstart();
      }
    };

    customElements.whenDefined('slideshow-component').then(() => requestAnimationFrame(start));
  })();

  } catch(e) { console.error(e); }
})();
})();
